import React, { Component } from "react";
import FadeInAnimation from "../Common/FadeInAnimation";
import Link from 'next/link';
import Image from "next/image";
import { useTranslations } from '../../locales/useTranslations';
import { BiLogoLinkedin } from "react-icons/bi";

const ÜberunsSimplifyData = () => {
  const { t } = useTranslations();
  return (
    <section className="about-area">
      <div className="container" style={{ marginTop: 50 }}>
        <div className="row align-items-center">
          <div className="col-lg-12">
            <div className="about-content">
              <span className="sub-title">{t('about_simplifyData_subtitle')}</span>
              <h2>{t('about_simplifyData_title')}</h2>
              <p>{t('about_simplifyData_greeting')}</p>
              <p>
                {t('about_simplifyData_introduction')}
              </p>
              <p>
                {t('about_simplifyData_background')}
              </p>
              <p>
                {t('about_simplifyData_passion')}
              </p>
              <p>
                {t('about_simplifyData_mission')}
              </p>
              <p>
                {t('about_simplifyData_values')}
              </p>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-sm-12">

            </div>
          </div>
        </div>
        <div className="features-card-section pt-70 pb-70">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-sm-12">
                <FadeInAnimation delay={50} animateOnce={true}>
                  <div className="single-team-box">
                    <div className="image">

                      <Image src="/images/about/sebastianrottgardt.webp" alt="Geschäftsführer Sebastian Rottgardt"
                        width={0}
                        height={0}
                        sizes="100vw"
                        style={{ width: '100%', height: 'auto' }} />
                      <ul className="social">
                        <li>
                          <Link href="https://www.linkedin.com/in/sebastian-rottgardt/" target="_blank">
                            <BiLogoLinkedin />
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="content">
                      <h3 >{t('about_team_sebastian_name')}</h3>
                      <span>{t('about_team_sebastian_position')}</span>
                    </div>
                  </div>
                </FadeInAnimation>
              </div>

              <div className="col-lg-6 col-sm-12">
                <FadeInAnimation delay={100} animateOnce={true}>
                  <div className="single-team-box">
                    <div className="image">
                      <Image src="/images/about/danielpantel.webp" alt="Geschäftsführer Daniel Pantel"
                        width={0}
                        height={0}
                        sizes="100vw"
                        style={{ width: '100%', height: 'auto' }} />
                      <ul className="social">
                        <li>
                          <Link
                            href="https://www.linkedin.com/in/daniel-pantel-748526156/"
                            target="_blank">
                            <BiLogoLinkedin />
                          </Link>
                        </li>
                      </ul>
                    </div>
                    <div className="content">
                      <h3>{t('about_team_daniel_name')}</h3>
                      <span>{t('about_team_daniel_position')}</span>
                    </div>
                  </div>
                </FadeInAnimation>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

}
export default ÜberunsSimplifyData;
